import { useNavigate } from 'react-router';
import { getQueryParams } from '../helpers/network';

export const useExceptionHandler = () => {
    const navigate = useNavigate();

    const handleException = (exception) => {
        const ref = window.location.pathname;
        const params = getQueryParams({ ...exception, ref });
        navigate(`/server-error?${params}`);
    };

    return {
        handleException
    };
};
